<div class="account-settings">
  <h1 class="account-settings__heading">Account Settings</h1>
  <div class="account-settings__body">
    <div class="account-settings__email">
      <h2 class="account-settings__headline">Change your email address</h2>
      <div class="account-settings__subheading">
        Changing your email address will also change the username you use to log in to your account. To confirm this
        change, please enter your account password.
      </div>

      <div class="account-settings__input-container">
        <div class="account-settings__input">
          <basic-text-input
            #settingsEmail
            class="account-settings__input"
            [propertyName]="'newEmail'"
            [placeholder]="'Email Address (this will be your login)'"
            [formatterType]="'email'"
            (valueChanged)="onEmailChanged()"
          ></basic-text-input>
        </div>
        <div *ngIf="!useAmc" class="account-settings__input">
          <basic-text-input
            #settingsPassword
            class="account-settings__input"
            [propertyName]="'password'"
            [placeholder]="'Password'"
            [inputType]="'password'"
          ></basic-text-input>
        </div>
      </div>

      <div class="account-settings__error error-message">{{ error }}</div>
      <button
        *ngIf="!emailResetIsRequested"
        class="button button--blue button--secondary account-settings__button"
        role="button"
        (click)="resetEmail()"
        [disabled]="emailResetIsRequested"
        [ngClass]="{ 'button--disabled': emailResetIsRequested }"
      >
        Submit
      </button>

      <div *ngIf="emailResetIsRequested" class="account-settings__email-change-confirmation">
        <img src="/img/components/account-settings/confirm-check.svg" class="account-settings__confirm-check" />
        <p *ngIf="!useAmc" class="account-settings__subheading">
          We sent an email to {{ displayEmail }}. Please check your email to verify this change.
        </p>
        <p *ngIf="useAmc" class="account-settings__subheading">
          We sent an email to {{ newEmail }}. Please check your email to verify and complete this change.
        </p>
      </div>
    </div>

    <div *ngIf="!useAmc" class="account-settings__password">
      <h1 class="account-settings__headline">Change your password</h1>
      <ng-container *ngIf="!resetConfirm">
        <div class="account-settings__subheading">
          A link to reset your password will be sent to the email address associated with your account:
          {{ displayEmail }}
        </div>
        <button
          class="button button--blue button--secondary account-settings__button"
          role="button"
          (click)="resetPassword()"
        >
          reset password
        </button>
      </ng-container>
      <div *ngIf="resetConfirm" class="account-settings__reset-confirmation">
        <img src="/img/components/account-settings/confirm-check.svg" class="account-settings__confirm-check" />
        <div class="account-settings__subheading">
          We sent your link. Please check your email and follow instructions to reset your password.
          <button (click)="resetPassword()" class="button-link">Resend</button>
        </div>
      </div>
    </div>

    <div *ngIf="useAmc" class="account-settings__password">
      <h1 class="account-settings__headline">Change your password</h1>

      <div *ngIf="passwordChanged" class="account-settings__email-change-confirmation">
        <img src="/img/components/account-settings/confirm-check.svg" class="account-settings__confirm-check" />
        <p class="account-settings__subheading">Your password has been successfully changed.</p>
      </div>

      <div *ngIf="!passwordChanged" class="account-settings__input-container">
        <div class="account-settings__input">
          <basic-text-input
            #settingsPassword
            class="account-settings__input"
            [propertyName]="'password'"
            [placeholder]="'Current Password'"
            [inputType]="'password'"
          ></basic-text-input>
        </div>
        <div class="account-settings__input">
          <basic-text-input
            #settingsNewPassword
            class="account-settings__input"
            [propertyName]="'newPassword'"
            [placeholder]="'New Password'"
            [inputType]="'password'"
          ></basic-text-input>
        </div>

        <div class="account-settings__error error-message">{{ passwordError }}</div>
        <button
          class="button button--blue button--secondary account-settings__button"
          role="button"
          (click)="resetPassword()"
        >
          reset password
        </button>
      </div>
    </div>
  </div>
</div>
